import { render, staticRenderFns } from "./SlotBookings.vue?vue&type=template&id=fae9a7a4&scoped=true&"
import script from "./SlotBookings.vue?vue&type=script&lang=ts&"
export * from "./SlotBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae9a7a4",
  null
  
)

export default component.exports